import React from 'react';
import { tokens as t, fonts as font } from '../../tokens';

export function Badge({ children, variant = "default" }) {
  const map = {
    default: { bg: "#f3f4f6",     color: t.textSecondary, border: t.border },
    emerald: { bg: t.emeraldLight, color: t.emeraldDeep,  border: `${t.emerald}40` },
    amber:   { bg: t.amberLight,   color: "#92500a",       border: `${t.amber}40` },
    danger:  { bg: t.coralLight,   color: "#9b2412",       border: `${t.coral}40` },
    sky:     { bg: t.skyLight,     color: "#1d4ed8",       border: `${t.sky}40` },
    purple:  { bg: t.purpleLight,  color: t.purple,        border: `${t.purple}40` },
  };
  const s = map[variant] || map.default;
  return (
    <span style={{
      display: "inline-flex", alignItems: "center",
      padding: "3px 9px", borderRadius: 5,
      background: s.bg, color: s.color,
      border: `1px solid ${s.border}`,
      fontSize: 11, fontWeight: 700, fontFamily: font.body,
      letterSpacing: "0.03em",
    }}>{children}</span>
  );
}

export function Tag({ label, color = t.emerald, onRemove }) {
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 4,
      padding: "3px 10px", borderRadius: 5,
      background: `${color}12`, color,
      border: `1px solid ${color}30`,
      fontSize: 11, fontWeight: 700, fontFamily: font.body,
    }}>
      {label}
      {onRemove && (
        <button onClick={onRemove} style={{ background: "none", border: "none", cursor: "pointer", color, fontSize: 13, padding: 0, lineHeight: 1, opacity: 0.5 }}>×</button>
      )}
    </span>
  );
}
